import { Injectable } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { Filter } from '../models/filter.model';
import { FilterOption } from '../interfaces/filteroption.interface';

@Injectable()
export class UrlHelper {
  constructor(private locationStrategy: LocationStrategy) {}

  /**
   * Update filter state from a URL
   * @param filters {Filter[]}
   * @returns {Filter[]}
   */
  public updateFilterFromUrl(filters: Filter[]): Filter[] {
    const path: string = this.locationStrategy.path();
    const filterParam: string = path.substring(
      path.indexOf('filter=') + 'filter='.length,
    );

    if (!filterParam) {
      return filters;
    }
    const queryString: string = decodeURIComponent(filterParam);
    let filtersResult: Filter[] = filters;

    try {
      const jsonObject = JSON.parse(queryString);
      filtersResult = this.updateFilterFromJson(jsonObject, filtersResult);
    } catch {
      // Ignore this
    }

    return filtersResult;
  }

  public filterToUrl(filters: Filter[]): string {
    let urlObject: Record<string, Record<string, boolean>> = {};
    filters.forEach((filter: Filter) => {
      filter.options.forEach((option: FilterOption) => {
        if (option.active) {
          urlObject = urlObject || {};
          urlObject[filter.name] = urlObject[filter.name] || {};
          urlObject[filter.name][option.name] = true;
        }
      });
    });

    let queryParams = '';
    if (Object.keys(urlObject).length) {
      const jsonString: string = JSON.stringify(urlObject);
      queryParams = `filter=${encodeURIComponent(jsonString)}`;
    }
    return queryParams;
  }

  /**
   * Create filters from json object
   * @param jsonObject {any}
   * @param filters {Filter[]}
   * @returns {Filter[]}
   */
  private updateFilterFromJson(
    jsonObject: Record<string, Record<string, boolean>>,
    filters: Filter[],
  ): Filter[] {
    const newFilters: Filter[] = filters.map((filter: Filter) =>
      filter.clone(),
    );
    newFilters.forEach((filter: Filter) => {
      const filterJson: Record<string, boolean> = jsonObject[filter.name];
      if (filterJson) {
        filter.options.forEach((option: FilterOption) => {
          if (option.name in filterJson) {
            option.active = filterJson[option.name];
          }
        });
      }
    });
    return newFilters;
  }
}
